import React from 'react'
import { CircularProgress, withStyles } from '@material-ui/core'

const styles = theme => ({
    root: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
    },

})

class Loading extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <div className={classes.root}>
                <CircularProgress className={classes.progress} variant="indeterminate" />
            </div>
        )
    }
}

export default withStyles(styles)(Loading)